import { TabContainer, TabList, TabButton, TabContent, CountContainer } from './tabs.style';
import { TabsComponentTypes } from './tabs.types';

const TabsComponent = ({
  value,
  onChange,
  color = 'primary',
  customColor,
  tabs = [],
  centered,
  children,
  bgColor = 'var(--theme-color-secondary)',
  heightfull,
}) => {
  const activeTab = tabs.find(tab => tab.value === value);
  const activeChild = Array.isArray(children)
    ? children[tabs.findIndex(tab => tab.value === value)]
    : children;

  return (
    <TabContainer $heightfull={heightfull}>
      {
        tabs && tabs.length > 1 &&
        <TabList centered={centered} role="tablist" $bgColor={bgColor}>
          {
            tabs.map((tab, index) => (
              <TabButton
                data-testid={`tab-${tab.value}`}
                key={index}
                $active={value === tab.value}
                disabled={tab.disabled}
                color={color}
                customcolor={customColor}
                onClick={() => onChange(tab.value)}
                role="tab"
                aria-selected={value === tab.value}
                aria-controls={`tabpanel-${tab.value}`}
              >
                {tab?.icon && <span>{tab?.icon}</span>}
                {tab?.label}
                {
                  tab?.count !== undefined && tab?.count > 0 &&
                  <CountContainer>{tab?.count}</CountContainer>
                }
              </TabButton>
            ))
          }
        </TabList>
      }

      <TabContent
        role="tabpanel"
        id={`tabpanel-${value}`}
        aria-labelledby={`tab-${value}`}
        $heightfull={heightfull}
        className='custom-scrollbar'
      >
        {children ? activeChild : (activeTab?.content || <div>No content available</div>)}
      </TabContent>
    </TabContainer>
  );
};


TabsComponent.propTypes = TabsComponentTypes;

export default TabsComponent;
